import React from 'react';

const FavoriteListingItem = ({
  label,
  icon,
  onClick,
  className = '',
}: {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  className?: string;
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`${className} flex w-full items-center gap-1.5x first:!pt-0 pt-2x first:!border-t-0 transition-colors hover:text-black border-t border-gray`}
  >
    <span className="shrink-0 text-gray__dark_2">{icon}</span>
    <span className="text-body-2 leading-none whitespace-nowrap text-gray__dark_1">
      {label}
    </span>
  </button>
);

export default FavoriteListingItem;
